import { takeLatest, takeEvery, fork, put, all, call } from 'redux-saga/effects'

import i18n from 'i18n'
import { jobAPI } from '../../../../../api'
import { jobJobCandidatesRecommendationsList } from './slice'
import { RequestUtils } from 'utils'
import { authLogoutPA } from 'features/auth/store'

function* getList({ payload: { id, params } }) {
  try {
    let requestParams = {
      for_job: params?.for_job,
      includes: ['studentProfile', 'avatar', 'receivedJobInvite'],
    }

    requestParams = RequestUtils.getMapRequestParams(params, requestParams)

    const response = yield call(jobAPI.getJobRecommendations, id, requestParams)

    const { data } = response

    const {
      meta: { current_page, last_page },
    } = data

    if (current_page && last_page && current_page > last_page) {
      yield put(
        jobJobCandidatesRecommendationsList.getList({
          params: {
            ...params,
            page: last_page,
          },
        })
      )
    } else {
      yield put(jobJobCandidatesRecommendationsList.getListSuccess(data))
    }
  } catch (error) {
    const message = error.response?.data?.message || i18n.t('error')
    yield put(jobJobCandidatesRecommendationsList.getListError(message))
  }
}

function* watchGetList() {
  yield takeLatest(jobJobCandidatesRecommendationsList.getList, getList)
}

function* cleanState() {
  yield put(jobJobCandidatesRecommendationsList.cleanState({}))
}

function* watchUserLogout() {
  yield takeEvery(authLogoutPA.success, cleanState)
}

export function* listSaga() {
  yield all([fork(watchGetList), fork(watchUserLogout)])
}
